import React, { Fragment } from 'react';
import { Icon } from '@paypalcorp/pp-react';
import PropTypes from 'prop-types';
import { intents } from '../../common/constants';
import { PayPalCreditIcon } from '../../common/svgImages';

function TopicIntentIcons(props) {
  const { refId, size, className, dataTestId } = props;

  const renderTopicIntentIcon = () => {
    switch (refId) {
      case intents.SEARCH:
        return <Icon name="search" size={size} className={className} data-testid={dataTestId} />;
      case intents.PAYMENTHOLD:
        return <Icon name="pending-paused" size={size} className={className} data-testid={dataTestId} />;
      case intents.DISPUTE_STATUS:
        return <Icon name="question" size={size} className={className} data-testid={dataTestId} />;
      case intents.REFUND:
        return <Icon name="refund" size={size} className={className} data-testid={dataTestId} />;
      case intents.UNAUTHORIZED_TRANSACTION:
      case intents.LIMITATION:
        return <Icon name="security" size={size} className={className} data-testid={dataTestId} />;
      case intents.TRANSFER:
        return <Icon name="transfer" size={size} className={className} data-testid={dataTestId} />;
      case intents.PAYMENT_DECLINE:
        return <Icon name="close" size={size} className={className} data-testid={dataTestId} />;
      case intents.PAY_IN_4:
      case intents.PAY_IN_3:
        return <Icon name="currency-dollar" size={size} className={className} data-testid={dataTestId} />;
      case intents.PAYPAY_CREDIT:
        return (
          <span className={`${className} sh_topic_intent__blob_icon_credit`} data-testid={dataTestId}>
            {PayPalCreditIcon}
          </span>
        );
      case intents.PAYMENT_DECLINE_OCP:
        return <Icon name="block" size={size} className={className} data-testid={dataTestId} />;
      case intents.ADD_CARD:
        return <Icon name="credit-card" size={size} className={className} data-testid={dataTestId} />;
      case intents.OVERFLOW:
        return <Icon name="overflow" size={size} className={className} data-testid={dataTestId} />;
      case intents.FILE_DISPUTE:
      default:
        return <Icon name="flag" size={size} className={className} data-testid={dataTestId} />;
    }
  };

  return <Fragment>{renderTopicIntentIcon()}</Fragment>;
}

TopicIntentIcons.propTypes = {
  size: PropTypes.string,
  className: PropTypes.string,
  refId: PropTypes.string,
  dataTestId: PropTypes.string,
};

export default TopicIntentIcons;
